import z, { ZodType } from 'zod';
import { Device } from './device';
import { playerSchema } from './player';

export type ActivateDeviceResponse = Device;

export const activateDeviceResponseSchema: ZodType<ActivateDeviceResponse> = z.object({
	id: z.number(),
	name: z.string(),
	isActive: z.boolean(),
	players: z.array(playerSchema),
});
